import {Tooltip} from '@material-ui/core';
import React from 'react';
import CancelIcon from '@material-ui/icons/Cancel';

type RecordStatusProps = {
  count: number;
};

export const CancelledRecords = ({count}: RecordStatusProps) => {
  return (
    <div className="record-status">
      <Tooltip title={`# of cancelled record(s):${count}`}>
        <CancelIcon className="status__canceled" />
      </Tooltip>
      <span className="record-count">{count}</span>
    </div>
  );
};

export default CancelledRecords;
